import script from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./ImportUploadFile.vue?vue&type=style&index=0&id=12ef3844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ef3844"]])

export default __exports__